import React,{useState,useEffect} from 'react';
import ProfileImg from '../../assets/images/dummy.png';
import { uploadProfile,isProfileConfirmed } from '../../actions/StudentAction'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faAngleRight, faArrowRight, faWarning, faCalendar, faCamera,faDownload, faEye } from '@fortawesome/free-solid-svg-icons';
import { getCourses } from '../../actions/RegisterActions';
import swal from 'sweetalert';
import { Link as DispatchLink } from 'react-router-dom';
import {Link} from 'react-scroll'


const EditAvatar = (props) => {
    const detail=props.detail
 
    const [fileName,setFileName]=useState({name:'fileName',value:'',erroor:'',isRequired:false})
    const [profilePic, setProfilePic] = useState({name : 'profilePic', value : ''});
    const[feeDetail,setFeeDetail]=useState(undefined)
    const [course, setCourse] = useState({ value: '', error: '', options: [], isRequired: false });
    const [confirmProfilePicture,setConfirmProfilePicture] = useState(false);


    useEffect(()=>{
        const feeDetail=props.feeDetail
        if(feeDetail!==undefined || feeDetail!==null){
            setFeeDetail(feeDetail)
        }
       
    },[props.detail, props.feeDetail])

    useEffect(async() => {
        const detail = props.detail !== undefined && props.detail
        if (detail !== undefined) {

        const courseRes = await getCourses(detail.country_id, detail.class_id, detail.center_id)
            setCourse({ ...course, options: courseRes.data, value: detail.course_id!==undefined?courseRes.data.filter(i=>i.id==detail.course_id)[0]:{} })
        }

      

    },[detail.country_id, detail.class_id, detail.center_id,])
    
    let courseContain =course.value !==undefined && course.value;
  
    const profileHandleChange = async(e) => {

        const filesValue = e.target.files;
        const formData = new FormData();
        formData.append('myImage',filesValue[0])
        formData.append('id',props.detail.id)


        await uploadProfile(formData).then(res => {
            if (res.status) {
                swal('Profile picture uploaded successfully','','success').then(function(){
                    const data = {
                        student_id:detail.id,
                        profile_picture_confirmed:0
                    }
                    isProfileConfirmed(data).then((res) => {
                        if(res.status){
                            setConfirmProfilePicture(true);
                        }
                    } )
                    
                })
                
                props.onSubmit(res)
            }
            else{
                swal('Something went wrong','','error')
            }
        })
        .catch(err => {
            console.log(err);
        })
        
    }

    const handleUpdateconfirmedProfilePicture = () => {
        const data = {
          student_id:detail.id,
          profile_picture_confirmed:1
      }
        isProfileConfirmed(data).then((res) =>{
            if(res.status){
                setConfirmProfilePicture(false);
            }
        });
      }

return (

<>
    {confirmProfilePicture &&
            <>
            <div className="overlay_popup"></div>
            <div className="modal-body rounded text-center bg-white p-5 shadow-sm w-50 mx-auto profile_complete_msg">
                    <p className="text-center">
                    <FontAwesomeIcon icon={faWarning} size='2xl' beatFade color='tomato' className='mb-3'/>
                    <h4 className="fw-bold mb-4">
                    Please confirm if you have uploaded an original recent photograph of yourself, as this will be used for all your academic purposes. </h4>
                    </p>
                    <p className="text-center"> Please go back and change if you have not, else click Confirm.</p>
                    <button className="btn mt-3 btn-primary px-5" onClick={handleUpdateconfirmedProfilePicture}>Confirm</button>
                    <button  className="btn mt-3 ms-2 btn-secondary py-2 px-5" onClick={(e) => setConfirmProfilePicture(false)}>Go Back</button>

            </div>
            </>
    }
    <div className="profile-design box mb-3" data-aos="fade-up" data-aos-duration="400">
        <div className="row">
            <div className="uppersec"></div>
        </div>
        <div className="lowersec">
            <div className="p-4 mt-negative">
                <div className="row">
                    <div className="col-lg-2 ">
                        <div className="position-relative w-130 profile_img">
                            {detail.profile_picture !==undefined && detail.profile_picture !==null  && detail.profile_picture !==''?<img src={`${process.env.REACT_APP_API_URL}/public/uploads/profile_picture/${detail.profile_picture}`} style={{width:'inherit'}} alt="Profile" className="rounded-circle" />
                            :<img src={ProfileImg} style={{width:'inherit'}} alt="Profile" className="rounded-circle" />}
                            <div className="icon-edit-profile">
                                <label  htmlFor="profileImg" className="label">
                                    <input type="file" className='d-none' name='profilePic'
                                     value={profilePic.value} accept="image/png, image/gif, image/jpeg" id="profileImg"
                                     onChange={e => profileHandleChange(e)}
                                      />
                                    <FontAwesomeIcon  icon={faCamera}/></label>
                            </div>
                        </div>
                        {detail.profile_picture !==undefined && (detail.profile_picture ==null  || detail.profile_picture ==='' )?
                        <>
                        <input type="file" className='d-none' name='profilePic'
                        value={profilePic.value} accept="image/png, image/gif, image/jpeg" id="profileImg"
                        onChange={e => profileHandleChange(e)}/>
                        <label htmlFor='profileImg' className='upload_picture_btn'>Upload your photo</label>
                         </>
                        :''}

                    </div>
                    <div className="col-lg-10 ">
                        <div className="d-flex align-items-center flex-wrap justify-content-between profile_header position-relative">
                            <h4 className="text-white st-profile-name ml-auto">{detail&&detail.name}</h4>
                            <>
                            {detail!==undefined && detail.tx_is_appeared==1 ? 
                            <DispatchLink className='btn result_btn dispatch_link  ms-auto me-2' state={{detail:detail}} to="/result">View Result</DispatchLink> :''
                        }
                            
                            {/* {detail.is_paid == 1 || detail.is_free == 1 ? 
                            <>
                            {detail.father_name !== "" && detail.parent_mobile!=="" ?
                             <DispatchLink to="/study-material-delivery-address" state={{detail:detail}}className='dispatch_link'>Dispatch Study Material &nbsp;  <FontAwesomeIcon  icon={faAngleRight}/></DispatchLink>
                             :<DispatchLink to="/dashboard" className='dispatch_link disable_btn'>Dispatch Study Material &nbsp;  <FontAwesomeIcon  icon={faAngleRight}/></DispatchLink>
                            }
                            </>
                            :''} */}
                            </>
                            <div className='avatar_course_form_detail'>
                            <span className="badge badge-sm">Form number : {detail&&detail.form_num}</span>
                            {courseContain.name!==undefined&& courseContain.name ?
                            <span className="badge badge-sm">Course : 
                            {detail&&detail.course !== null && detail.course}
                            </span>
                            :''
                        }
                        
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2">
                    </div>
                    <div className="col-lg-10">
                        <div className="profile-status">
                            <div className="row justify-content-start">
                                <div className="col-lg-4 col-md-4 col-sm-12 col-12 mt-3 mt-md-0">
                                    <div className="card-shadow-danger widget-chart widget-chart2">
                                        <div className="widget-content">
                                            <div className="widget-content-outer">
                                                <div className="widget-content-wrapper">
                                                    <div className="widget-content-left pr-2 fsize-1">
                                                        <span className="widget-numbers mt-0 fsize-3 text-primary">
                                                            Profile Completion : {detail.profCompletePercentage}%</span>
                                                    </div>
                                                    <div className="widget-content-right w-100 mt-2">
                                                        <div className="progress-bar-xs progress">
                                                            <div className="progress-bar bg-primary" role="progressbar"
                                                                aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"
                                                                style={{width : detail.profCompletePercentage+ '%'}}></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                {feeDetail!==undefined && feeDetail!==null?<>
                                {feeDetail.pending &&feeDetail.pending > 0?<>
                                <div className="col-lg-4 col-md-4 col-sm-6 col-12 mt-3 mt-md-0">
                                    <span>{feeDetail&&feeDetail.installments_number}<sup>st</sup> Installment Paid On :</span>
                                    <h4 className="text-warning"><FontAwesomeIcon icon={faCalendar}/> {feeDetail&&feeDetail.transaction_date} &nbsp; 
                                    <DispatchLink to={`/my-transactions/${detail?.id}`} className='btn btn-sm btn-secondary'>Receipts <FontAwesomeIcon icon={faEye}/></DispatchLink>
                                    </h4>
                                   
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6 col-12 mt-3 mt-md-0">
                                    <span>{feeDetail&&feeDetail.installments_number+1}<sup>nd</sup> Installment Due On :</span>
                                    <h4 className="text-danger"><FontAwesomeIcon icon={faCalendar}/> {feeDetail&&feeDetail.next_inst_date} &nbsp; 
                                    <Link to="payNow_btn" spy={true} onClick={props.showPayFeeBox}  className='d-inline-block btn ms-auto btn-sm  btn-warning'>Pay now</Link>
                                    </h4>
                                   
                                </div>
                                </>:
                                <>
                                 {/* Show paid fees */}
                                {detail?.is_paid ==1 &&
                                 <div className="col-lg-4 col-md-4 col-sm-12 col-12 mt-3 mt-md-0 ms-lg-5 ps-lg-5">
                                    <span>Fee Paid On :</span>
                                    <h4 className="text-warning"><FontAwesomeIcon icon={faCalendar}/> {feeDetail&&feeDetail.transaction_date} &nbsp; 
                                    <DispatchLink to={`/my-transactions/${detail?.id}`}  className='btn btn-sm btn-secondary'>Receipts <FontAwesomeIcon icon={faEye}/></DispatchLink>
                                    {/* <button type="button" className="btn btn-sm btn-secondary" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                                    Reciept <FontAwesomeIcon icon={faEye}/>
                                    </button> */}
                                    </h4>
                                   
                                </div>
                                }
                                </>}
                                </>:
                                <>
                                <div className='col-lg-8'>
                                {courseContain.name!==undefined&& courseContain.name && detail?.is_paid !==1 ?
                                <div className='pay_btn text-end'>
                                <Link to="payNow_btn" spy={true} onClick={props.showPayFeeBox}  className='d-inline-block btn ms-auto btn-sm px-5 py-2 btn-warning mt-2'>Pay Fee now</Link>  
                                </div>
                                :''}
                                </div>
                                
                                </>}
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>


    {/* Recipet Dialog */}
{/* <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div className="modal-dialog modal-xl">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="staticBackdropLabel">Fee Acknowledgement</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body receipt_modal_body">
       { feeDetail!==null &&feeDetail!==undefined&&<Receipt showId="receipt_save" detail={detail} feeDetail={feeDetail} /> }
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type='primary' className="ps-2 btn bg-primary text-white" onClick={generateReceiptBtn}> Receipt &nbsp; <FontAwesomeIcon icon={faDownload}/></button>
      </div>
    </div>
  </div>
</div> */}
</>
)
}

export default EditAvatar
